import React,{useState} from 'react';
import Nav from 'react-bootstrap/Nav';
import {  Dropdown } from 'react-bootstrap';
import './navitems.scss'
const TabNavItem = ({ tabnavitems }) => {
    const [selectedTitle, setSelectedTitle] = useState(tabnavitems[0].title);
    const handleSelect = (eventKey) => {
        const selectedItem = tabnavitems.find(item => item.eventKey === eventKey);
        setSelectedTitle(selectedItem.title);
    };
    return (
        <div className='navtabsitems'>
            <div className='dropdown-container d-block d-md-none'>
                <Dropdown onSelect={handleSelect}>
                    <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                        {selectedTitle}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {tabnavitems.map((item, index) => (
                            <Dropdown.Item key={index} eventKey={item.eventKey}>
                                {item.title}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <div className='tabs-container d-none d-md-block'>
                {tabnavitems.map((item, index) => (
                    <Nav.Item key={index}>
                        <Nav.Link eventKey={item.eventKey}>{item.title}</Nav.Link>
                    </Nav.Item>
                ))}
            </div>
        </div>
    );
}

export default TabNavItem;
